import { RefObject, useEffect, useState } from 'react'

/**
 * 単一の要素がviewport上に表示されているかを監視する
 */
const useIntersectionObserver = (
  ref: RefObject<HTMLElement> | undefined,
  defaultIntersecting = true,
  options?: IntersectionObserverInit
): { isIntersecting: boolean; isBelow: boolean } => {
  const [isIntersecting, setIsIntersecting] = useState<boolean>(defaultIntersecting)
  const [isBelow, setIsBelow] = useState<boolean>(false)

  useEffect(() => {
    if (!ref?.current) return
    const callback = (entries: IntersectionObserverEntry[]) => {
      setIsIntersecting(entries[0].isIntersecting)
      setIsBelow(entries[0].boundingClientRect.bottom < window.innerHeight)
    }
    const observer = new IntersectionObserver(callback, options)
    observer.observe(ref.current)
    return () => {
      observer.disconnect()
    }
  }, [ref?.current, options])

  return { isIntersecting, isBelow }
}

export default useIntersectionObserver
